import React from "react";
import "./PDFPreviewModal.css";

interface PDFPreviewModalProps {
  file: string;
  fileName: string;
  isOpen: boolean;
  onClose: () => void;
}

const PDFPreviewModal: React.FC<PDFPreviewModalProps> = ({ file, fileName, isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = file;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="pdf-preview-modal-overlay">
      <div className="pdf-preview-modal">
        <div className="pdf-preview-header">
          <h3>{fileName}</h3>
          <div className="pdf-preview-actions">
            <button className="btn btn-secondary btn-small" onClick={handleDownload}>
              Herunterladen
            </button>
            <button className="btn btn-primary btn-small" onClick={onClose}>
              Schließen
            </button>
          </div>
        </div>
        <div className="pdf-preview-content">
          <iframe
            src={file}
            title={fileName}
            className="pdf-iframe"
            frameBorder="0"
          />
        </div>
      </div>
    </div>
  );
};

export default PDFPreviewModal;
